import { useQuery } from "@tanstack/react-query";
import { getCoupons } from "../services/get-active-coupons";

export function useCoupons() {
  return useQuery({
    queryKey: ["coupons"],
    queryFn: () => getCoupons(),
  });
}
